module.exports = __webpack_public_path__ + "img/18_50.bf428c51.png";